import React from 'react'
import 'materialize-css/dist/css/materialize.min.css';
import avatar from '../img/avatar.png'
import Streams from '../components/Streams';
import Socials from '../components/Socials';
import Videos from '../components/Videos';


export default function Home() {
  return (
    <div className='secondblue-bg'>
      <div className='container hero'>
        <div className='row'>
          <div className='col m6'>
            <h1>D1sabl3d</h1>
            <h3>Chess streamer from Sweden</h3>
          </div>
          <div className='col m6 center'>
            <img alt='avatar' src={avatar} className='hero-image'/>
          </div>
          <div className='center'>
            <Socials />
          </div>
          
        </div>
      </div>
      <div className='secondary-blue divider-top center'>
        <div className='container'>
          <h1 className='yellowtext'>Who am I</h1>
          <p className='yellowtext infotext'>My name is Sebastian, but more known as D1sabl3d online. I am a competitive chess player with Cerebral Palsy that started streaming chess during the covid pandemic. My chess club started participating in online tournaments and I thought to myself "Why not stream these?". When the pandemic was over, I kept going. Today, I am streaming and posting videos on YouTube, Twitch, TikTok and Instagram weekly to share my passion for chess and inspire others to start playing the game.</p>
        </div>
      </div>
      <div className='secondary-blue divider-top center'>
        <div className='container'>
          <Streams/>
        </div>
      </div>
      <div className='secondary-blue divider-top center'>
        <div className='container'>
          <Videos/>
        </div>
      </div>
    </div>
  )
}